import { useEffect, useState } from 'react';
import { Button, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { Overlay } from '@eti/components';
import isFunction from 'lodash/isFunction';
import { FORM_SECTION } from '../../utils/constants';
import { getNewActiveBundle } from '../../utils/utils';
import BundleModalContent from './BundleModalContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const generateOptionKey = index => `option_${index}`;
const buttonWrapperStyles = css`
  background-color: ${vars.colors.surface.primary};
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
`;
const BundleModal = ({
  isTDOrStepPage,
  onChange,
  onClose,
  options,
  selectedBundleToOpen,
  setSelectedBundleToOpen,
  shouldShow
}) => {
  var _activeBundle$feature;
  const {
    t
  } = useTranslation();
  const [activeBundle, setActiveBundle] = useState(() => getNewActiveBundle(options, selectedBundleToOpen));
  const handleChange = () => {
    if (isFunction(onChange)) {
      onChange({
        value: activeBundle.id
      }, `${FORM_SECTION}.value`);
      const radioButton = document.getElementById(`choice.ancillaryBundle.${activeBundle.id}`);
      if (radioButton) {
        radioButton.focus();
      }
    }
    if (!isTDOrStepPage) {
      const selectedBundleElement = Array.from(document.getElementsByName('value')).find(element => {
        return element.value === activeBundle.id;
      });
      selectedBundleElement === null || selectedBundleElement === void 0 || selectedBundleElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setSelectedBundleToOpen(null);
  };
  useEffect(() => {
    if (selectedBundleToOpen) {
      setActiveBundle(getNewActiveBundle(options, selectedBundleToOpen));
    }
  }, [options, selectedBundleToOpen]);
  return /*#__PURE__*/_jsxs(Overlay.Drawer, {
    dataTestId: "modal-overlay-drawer",
    handleClose: onClose,
    id: "product-bundle-info-drawer",
    isOpen: shouldShow,
    children: [/*#__PURE__*/_jsx(Overlay.Header, {
      onClose: onClose,
      title: activeBundle === null || activeBundle === void 0 ? void 0 : activeBundle.title
    }), /*#__PURE__*/_jsx(Overlay.Content, {
      "data-testid": "modal-overlay-drawer-content",
      children: activeBundle === null || activeBundle === void 0 || (_activeBundle$feature = activeBundle.features) === null || _activeBundle$feature === void 0 ? void 0 : _activeBundle$feature.map((item, index) => /*#__PURE__*/_jsx(BundleModalContent, {
        bundleDescription: item.description,
        bundleName: item.name,
        bundleReadMoreText: item.readMoreText,
        dimensions: null,
        id: index,
        piecesAndWeight: null,
        termsUrl: null
      }, generateOptionKey(`product-bundle_tab_feature_${index}`)))
    }), /*#__PURE__*/_jsx(Overlay.Footer, {
      children: /*#__PURE__*/_jsx("div", {
        className: buttonWrapperStyles,
        children: /*#__PURE__*/_jsx(Button, {
          "aria-describedby": "modal-title",
          "data-testid": `${selectedBundleToOpen}-readMoreDrawer-selectButton`,
          onClick: handleChange,
          variant: "primary",
          children: t('Product.Bundle.Select.Button.Text')
        })
      })
    })]
  });
};
export default BundleModal;
//# sourceMappingURL=BundleModal.js.map